import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/logo2.png'

const Navbar = () => {
    const [expanded, setExpanded] = useState(false);

    const handleNavItemClick = () => {
        setExpanded(false); // Collapse the navbar when an item is clicked
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/" onClick={handleNavItemClick}> <img src={logo}/><b>HEALTH CLINIC </b></Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded={expanded ? "true" : "false"}
                        aria-label="Toggle navigation"
                        onClick={() => setExpanded(!expanded)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/" onClick={handleNavItemClick}>Home</Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className="nav-link" to="/about" onClick={handleNavItemClick}>About</Link>
                            </li> */}
                            <li className="nav-item">
                                <Link className="nav-link" to="/Vivek" onClick={handleNavItemClick}>Dr. Vivek Pandey</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/Priyanka" onClick={handleNavItemClick}>Dr. Priyanka Pandey</Link>
                            </li>

                            {/* Appointment Dropdown */}
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="appointmentDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    Appointment
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="appointmentDropdown">
                                    <li><Link className="dropdown-item" to="/Contact" onClick={handleNavItemClick}>Book Appointment</Link></li>
                                </ul>
                            </li>

                            
                            

                            {/* Support & Security Dropdown */}
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="supportDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    General Services
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="managementDropdown">
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Infections</Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Metabolic diseases</Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Blood pressure</Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Tummy aches</Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Headaches</Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Muscular weakness</Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Epilepsy</Link></li>
                                </ul>



                            </li>


                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="managementDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    General Dentistry
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="managementDropdown">
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>Scaling, Rct, extraction </Link></li>
                                    <li><Link className="dropdown-item" to="/dental-treatment" onClick={handleNavItemClick}>General- Dental problems</Link></li>
                                   
                                </ul>

                            </li>
                            
                            <li className="nav-item">
                                <Link className="nav-link" to="/Gallery" onClick={handleNavItemClick}>Gallery</Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
